exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-about-heather-js": () => import("./../../../src/pages/about-heather.js" /* webpackChunkName: "component---src-pages-about-heather-js" */),
  "component---src-pages-about-jan-js": () => import("./../../../src/pages/about-jan.js" /* webpackChunkName: "component---src-pages-about-jan-js" */),
  "component---src-pages-about-rebecca-js": () => import("./../../../src/pages/about-rebecca.js" /* webpackChunkName: "component---src-pages-about-rebecca-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

